import { render, staticRenderFns } from "./supporter-criteria-panel.vue?vue&type=template&id=46425288&scoped=true&"
import script from "./supporter-criteria-panel.vue?vue&type=script&lang=ts&"
export * from "./supporter-criteria-panel.vue?vue&type=script&lang=ts&"
import style0 from "./supporter-criteria-panel.vue?vue&type=style&index=0&id=46425288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46425288",
  null
  
)

export default component.exports